import type { UiNode, UiText } from '@ory/client';
import { Label } from '@/components/ui/label';
import { useNodeTranslation } from '@/features/auth/hooks/useNodeTranslation';
type Props = {
  node: UiNode;
};

/**
 * Textノードコンポーネント
 *
 * Ory KratosのServer Driven UIで返されるtextノードをレンダリングします。
 * 主にTOTPのシークレットキーやリカバリーコードなどの情報を表示するために使用されます。
 *
 * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#ui-text-nodes
 */
export function TextNode({
  node
}: Props) {
  const {
    translateUiText
  } = useNodeTranslation();

  // textノードでない場合は何もレンダリングしない
  if (node.type !== 'text') {
    return null;
  }
  const attrs = node.attributes as {
    text?: UiText;
    id?: string;
    node_type?: string;
  };

  // text属性が存在しない場合は何もレンダリングしない
  if (!attrs.text) {
    return null;
  }

  // テキストコンテンツを翻訳
  const textContent = translateUiText(attrs.text);

  // ラベルを翻訳（存在する場合）
  const label = node.meta?.label ? translateUiText(node.meta.label) : undefined;
  return <div id={attrs.id} className="space-y-1">
      {label && <Label className="text-xs text-neutral-muted-on-fill">{label}</Label>}
      <div className="text-sm text-neutral-on-fill break-all">
        {textContent}
      </div>
    </div>;
}